import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/sharp-solid-svg-icons';
import React from 'react';

type Props = {
  className?: string;
  size?: SizeProp;
};

const LoadingIcon: React.FC<Props> = ({
  className = undefined,
  size = 'xl',
}) => {
  return (
    <FontAwesomeIcon
      spinPulse
      className={className}
      icon={faSpinner}
      size={size}
    />
  );
};

export default LoadingIcon;
